module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked@4x.a51b5606.png";